import Swiper from 'swiper';
import domReady from '@wordpress/dom-ready';

domReady(() => {
  const latestNewsSwiper = document.querySelector('.latest-news-swiper');

  if (latestNewsSwiper) {
    new Swiper(latestNewsSwiper, {
      slidesPerView: 1.1,
      spaceBetween: 20,
      draggable: true,
      navigation: {
        nextEl: '.latest-news-block__swiper-nav .swiper-button-next',
        prevEl: '.latest-news-block__swiper-nav .swiper-button-prev',
      },
      breakpoints: {
        590: {
          slidesPerView: 2.25,
        },
        840: {
          slidesPerView: 3,
          spaceBetween: 24,
        },
      },
      a11y: {
        enabled: true,
        slideRole: '',
      },
    });
  }
});
